import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import mixpanel from 'mixpanel-browser';
import { TextField, Button } from '@mui/material';
import NavBar from '../../NavBar';
import { Footer } from '../Footer';
import { surveyText, surveyBtnAnswers, uiExperience } from '../../../constants/Footer/survey';
import { SurveyBtns } from './SurveyBtns';
import { postSurvey } from '../../../actions/index.js';

import './Survey.css';

export const Experience = () => {
  const [answerChosen, setAnswerChosen] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    mixpanel.track('UI Experience Survey Page', {
      path: '/survey_UIExperience',
    });
  }, []);

  const handleAnswer = (question, answer) => {
    setAnswerChosen((prevState) => ({
      ...prevState,
      [question]: answer,
    }));
  };

  const handleSubmit = async () => {
    if (Object.keys(answerChosen).length < 10) {
      //hard coded length of questions
      alert('Please answer all questions before submitting!');
      return;
    }
    mixpanel.track('UI Experience Survey Submitted', {
      path: '/survey_UIExperience',
      answers: answerChosen,
    });

    const surveyData = uiExperience.map((item) => ({
      questionsDifficult: item.questionsDifficult?.map((question) => ({
        question,
        answer: answerChosen[question],
      })),
      questionsAppealing: item.questionsAppealing?.map((question) => ({
        question,
        answer: answerChosen[question],
      })),
      questionYesNo: item.questionYesNo?.map((question) => ({
        question,
        answer: answerChosen[question],
      })),
      questionsSatisfied: item.questionsSatisfied?.map((question) => ({
        question,
        answer: answerChosen[question],
      })),
      feedback: item.feedback?.map((question) => ({
        question,
        answer: answerChosen[question],
      })),
    }));

    dispatch(
      postSurvey({
        surveyType: 'UI Experience',
        surveyData: surveyData,
      }),
    );
    navigate('/survey_thankyou');
  };

  return (
    <>
      <NavBar />
      <div className="surveyContainer">
        <div className="surveyHeader">
          <h1 className="surveyh1">{surveyText.title}</h1>
          <p className="surveyp">{surveyText.subtitle}</p>
          <h2 className="header"> {surveyText.uiExperienceTitle} </h2>
          <p className="surveysubp"> {surveyText.uiExperienceSubtitle} </p>
        </div>

        {uiExperience.map((item, index) => (
          <div key={index}>
            <div className="content">
              {item.questionsDifficult &&
                item.questionsDifficult.map((question, questionIndex) => (
                  <div key={question.questionId}>
                    <h3 className="questionh3">{question.text}</h3>
                    <SurveyBtns
                      questionCategory={surveyBtnAnswers[0].difficult}
                      questionAnswer={handleAnswer}
                      question={question.text}
                    />
                  </div>
                ))}

              {item.questionsAppealing &&
                item.questionsAppealing.map((question, questionIndex) => (
                  <div key={question.questionId}>
                    <h3 className="questionh3">{question.text}</h3>
                    <SurveyBtns
                      questionCategory={surveyBtnAnswers[0].appealing}
                      questionAnswer={handleAnswer}
                      question={question.text}
                    />
                  </div>
                ))}

              {item.questionYesNo &&
                item.questionYesNo.map((question, questionIndex) => (
                  <div key={question.questionId}>
                    <h3 className="questionh3">{question.text}</h3>
                    <SurveyBtns
                      questionCategory={surveyBtnAnswers[0].yesNo}
                      questionAnswer={handleAnswer}
                      question={question.text}
                    />
                  </div>
                ))}

              <div>
                <h3 className="questionh3">{item.questionsSatisfied}</h3>
                <SurveyBtns
                  questionCategory={surveyBtnAnswers[0].satistied}
                  questionAnswer={handleAnswer}
                  question={item.questionsSatisfied}
                />
              </div>

              <div>
                <h3 className="questionh3">{item.feedback}</h3>
                <TextField
                  id="outlined-multiline-static"
                  multiline
                  fullWidth
                  rows={4}
                  placeholder="Write here..."
                  question={item.feedback}
                  onChange={(e) => {
                    handleAnswer(item.feedback, e.target.value);
                  }}
                />
              </div>

              <Button variant="contained" id="submitSurveyBtn" onClick={handleSubmit}>
                {surveyText.submit}
              </Button>
            </div>
          </div>
        ))}
      </div>
      <Footer />
    </>
  );
};
